<template>
  <div>
    <h4>Gatilladores de la ejecución:</h4>
    <table
      class="uk-table uk-table-hover uk-table-divider"
      style="border-collapse: collapse; width: 100%;"
    >
      <tr>
        <th class="uk-text-center uk-padding-small">Estado</th>
        <th class="uk-text-left uk-padding-small">Estado del gatillador</th>
        <th class="uk-text-left uk-padding-small">Proceso</th>
      </tr>
      <tr
        v-for="gatillador in fileOnFlow.detalle.baseGatillaciones" :key="gatillador.id"
        style="border-bottom: 1px solid #e5e5e5;"
      >
        <td class="uk-text-center uk-padding-small">
          <span>
            <i
              v-if="+gatillador.aprobacionesGatilladorEstado === 1"
              title="Ejecutado"
              class="material-icons"
              style="color: green;"
            >check_circle</i>
            <i
              v-else-if="+gatillador.aprobacionesGatilladorEstado === 2"
              title="PROCESANDO"
              class="material-icons"
            >spin</i>
            <i
              v-else-if="+gatillador.aprobacionesGatilladorEstado === 3"
              title="ERROR"
              class="material-icons"
              style="color: red;"
            >cancel</i>
            <i
              v-else
              title="Pendiente"
              class="material-icons"
            >indeterminate_check_box</i>
          </span>
        </td>
        <td class="uk-text-left uk-padding-small">
          {{ gatillador.estado }}
        </td>
        <td class="uk-text-left uk-padding-small">
          {{ gatillador.proceso }}
        </td>
      </tr>
    </table>
    <div
      v-if="fileOnFlow.detalle.pasosGatillaciones
      && fileOnFlow.detalle.pasosGatillaciones.length > 0"
    >
      <hr style="margin: 20px 0;">
      <h4>Gatilladores de los pasos:</h4>
    </div>
    <table
      class="uk-table uk-table-hover uk-table-divider"
      style="border-collapse: collapse; width: 100%;"
    >
      <tr>
        <th class="uk-text-center uk-padding-small">Estado</th>
        <th class="uk-text-left uk-padding-small">Estado del paso</th>
        <th class="uk-text-left uk-padding-small">Nº Paso</th>
        <th class="uk-text-left uk-padding-small">Proceso</th>
      </tr>
      <tr
        v-for="gatillador in gatillacionesPasos" :key="gatillador.id"
        style="border-bottom: 1px solid #e5e5e5;"
      >
        <td class="uk-text-center uk-padding-small">
          <span>
            <i
              v-if="+gatillador.aprobacionesGatilladorEstado === 1"
              title="Ejecutado"
              class="material-icons"
              style="color: green;"
            >check_circle</i>
            <i
              v-else-if="+gatillador.aprobacionesGatilladorEstado === 2"
              title="PROCESANDO"
              class="material-icons"
            >spin</i>
            <i
              v-else-if="+gatillador.aprobacionesGatilladorEstado === 3"
              title="ERROR"
              class="material-icons"
              style="color: red;"
            >cancel</i>
            <i
              v-else
              title="Pendiente"
              class="material-icons"
            >indeterminate_check_box</i>
          </span>
        </td>
        <td class="uk-text-left uk-padding-small">
          {{ gatillador.estado }}
        </td>
        <td class="uk-text-center uk-padding-small">
          {{ gatillador.paso.numeroPaso }}
        </td>
        <td class="uk-text-left uk-padding-small">
          {{ gatillador.proceso }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ModalConsecuences',
  props: {
    file: { type: Object, required: true },
    fileOnFlow: { type: Object, required: true }
  },
  computed: {
    gatillacionesPasos() {
      const gatillaciones = this.fileOnFlow.detalle.pasosGatillaciones || [];
      const pasos = this.fileOnFlow.detalle.pasos || [];
      return gatillaciones.map((gatillador) => {
        const paso = pasos.find((p) => p.id === gatillador.aprobacionesPasoEjecucionId);
        return {
          ...gatillador,
          paso
        };
      });
    },
  }
};
</script>
